import EventEmitter from 'owa-event-emitter';
import { PreviewPaneMode } from '../store/schema/PreviewPaneViewState';
import SxSViewState, { RightPaneDisplay } from '../store/schema/SxSViewState';

export default function getInitialSxSViewState(): SxSViewState {
    return {
        previewPane: {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (11,13): Type 'null' is not assignable to type 'string | undefined'.
            // @ts-expect-error
            downloadUrl: null,
            mode: PreviewPaneMode.Blank,
        },
        didAutoHideRightPane: false,
        hideRightPane: false,
        rightPaneSize: 0,
        leftPaneSizePixels: 0,
        rightPaneSizePixels: 0,
        rightPaneDisplay: RightPaneDisplay.Initial,
        eventManager: new EventEmitter(),
    };
}
